import { FileModel } from "@aecom/core";
import { Injectable, inject } from "@angular/core";
import { BBJFileUrlProvider, blobFolderFromUrl } from "@bbj/components";
import { lastValueFrom } from "rxjs";
import { CorrespondenceDocumentsService } from "../api-generated";

/**
 * Mints a fresh SAS URL at click time instead of reusing the one the document list was loaded with.
 * Those expire after 30 minutes, so on a page left open a while every stored link is already dead.
 */
@Injectable({
  providedIn: "root",
})
export default class CorrespondenceFileUrlProvider extends BBJFileUrlProvider {
  private documentsService = inject(CorrespondenceDocumentsService);

  getPreviewUrl(item: FileModel): Promise<string> {
    return this.mintUrl(item, false);
  }

  getDownloadUrl(item: FileModel): Promise<string> {
    return this.mintUrl(item, true);
  }

  private mintUrl(item: FileModel, forceDownload: boolean): Promise<string> {
    return lastValueFrom(
      this.documentsService.correspondenceGenerateURL({
        id: blobFolderFromUrl(item.URL),
        name: item.Name,
        forceDownload,
      }),
    );
  }
}
